module.exports = __webpack_public_path__ + "img/mailbox.7dff591d.svg";